import { FlowTypes, MobileDeviceValues } from "@trailhead/smart-setup-core";
import { FactoryTypes, FieldID } from "../../../models";

export const sendBackContent = (oldPhone: MobileDeviceValues) => ({
  criteria: {
    oldPhone,
    oldDeviceAccess: true,
    deviceFlowType: FlowTypes.Replacement,
  },
  content: [
    {
      type: FactoryTypes.TIPBOX,
      fieldMapping: {
        text: FieldID.guideContainer.tipBox.tipReturnOldDevice,
        icon: FieldID.guideContainer.tipBox.icon,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.removeSimCardAndBattery.text,
      },
    },
    {
      type: FactoryTypes.TIPBOX,
      fieldMapping: {
        text: FieldID.guideContainer.tipBox.simBatteryOrSDCardNotAccessible,
        icon: FieldID.guideContainer.tipBox.iconV2,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.stepUspsTrackingOnPhoneClaim.text,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.placePhoneInEnvelope.text,
      },
    },
    {
      type: FactoryTypes.EXPERT_HELP,
      fieldMapping: {
        buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
        title: FieldID.guideContainer.expertHelpContent.title,
        subtext: FieldID.guideContainer.expertHelpContent.subtext,
        secondaryButtonText:
          FieldID.guideContainer.expertHelpContent.secondaryButtonText,
        supportNumber: FieldID.guideContainer.expertHelpContent.supportNumber,
        icon: FieldID.guideContainer.expertHelpContent.icon,
      },
    },
  ],
});
